import MainStore from "@/store";
import MainRouter from "@/router";

import localStore from "./store";
import localRoutes from "./router";

MainStore.registerModule("policy", localStore);
MainRouter.addRoutes(localRoutes);
